import styled from "styled-components";

import { media } from "constants/media";

export const OverviewHero = styled.div`
    margin: 0 -24px;
    min-height: 112px;
    padding: 0 24px;
    position: relative;
    width: calc(100% + 48px);

    ${media.mdUp} {
        align-items: flex-end;
        display: flex;
        position: static;
    }
`;
export const OverviewHeroImage = styled.div`
    bottom: 0;
    position: absolute;
    right: 0;
    width: 121px;
    z-index: -1;

    ${media.mdUp} {
        margin-right: 48px;
        position: static;
        transform: scaleX(-1);
        width: 264px;
    }
`;
export const Title = styled.h1`
    display: block;
    font-size: 40px;
    font-weight: normal;
    line-height: 56px;

    ${media.mdUp} {
        font-size: 56px;
        line-height: 80px;
    }
`;

export const TitleAndDistanceCalculator = styled.div`
    max-width: 888px;

    ${media.mdUp} {
        display: flex;
        flex-direction: column;
        gap: 16px;
        padding-bottom: 24px;
    }

    ${media.lgUp} {
        gap: 24px;
        padding-bottom: 48px;
        width: 100%;
    }
`;
